<template>
  <div class="carousel-card">
    <div class="carousel-image  ">

      <!-- IMAGEN DEL AGENTE -->
      <div v-if="isLoadingImages" class="image-loader">
        <div class="spinner"></div>
      </div>
      <img
        v-if="detailCardAgente?.img_url"
        class="img-card"
        :src="detailCardAgente.img_url"
        :alt="$t('agents.heading')"
        width="400"
        height="400"
        loading="lazy"
        decoding="async"
        @load="handleImageLoad"
        @error="handleImageError"
      />

      <!-- PLACEHOLDER CUANDO NO HAY IMAGEN -->
      <div v-else class="no-image">
        <div class="circle bg-icon-danger big">
          <i class="fa-solid fa-user danger"></i>
        </div>
      </div>

      <!-- BADGE DE PROPIEDADES -->
      <!-- <div class="badge-container">
        <span class="badge bg-red">
          {{ propiedadesTexto }}
        </span>
      </div> -->

      <!-- HOVER -->
      <div class="hover-content">
        <div class="social-icons">
          <a
            v-if="detailCardAgente?.Facebook_url"
            class="text-white"
            :href="detailCardAgente.Facebook_url"
            target="_blank"
          >
            <i class="pointer fab fa-facebook"></i>
          </a>

          <a
            v-if="detailCardAgente?.Twitter_url"
            class="text-white"
            :href="detailCardAgente.Twitter_url"
            target="_blank"
          >
            <i class="pointer fab fa-twitter"></i>
          </a>

          <a
            v-if="detailCardAgente?.LinkedIn_url"
            class="text-white"
            :href="detailCardAgente.LinkedIn_url"
            target="_blank"
          >
            <i class="pointer fab fa-linkedin"></i>
          </a>
        </div>

        <p class="connect-text">{{ $t('contactAgent.connect') }}</p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "AgenteCard",

  props: {
    detailCardAgente: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  data() {
    return {
      isLoadingImages: true,
      imageLoadError: false
    };
  },

  mounted() {
    if (this.detailCardAgente?.img_url) {
      this.preloadImage();
    } else {
      this.isLoadingImages = false;
    }
  },

  watch: {
    detailCardAgente: {
      handler(newVal) {
        if (newVal?.img_url) {
          this.imageLoadError = false;
          this.preloadImage();
        } else {
          this.isLoadingImages = false;
        }
      },
      immediate: true
    }
  },

  computed: {
    propiedadesTexto() {
      const total = this.detailCardAgente?.Propiedades?.length || 0
      return `${total} ${total === 1 ? 'propiedad' : 'propiedades'}`
    }
  },

  methods: {
    handleImageLoad() {
      this.isLoadingImages = false;
    },
    handleImageError() {
      this.imageLoadError = true;
      this.isLoadingImages = false;
    },
    preloadImage() {
      this.isLoadingImages = true;
      const img = new Image();
      img.onload = () => {
        this.isLoadingImages = false;
      };
      img.onerror = () => {
        this.isLoadingImages = false;
      };
      img.src = this.detailCardAgente.img_url;
    }
  }
}
</script>

<style scoped>
.carousel-card {
  height: 17rem;
  width: 100%;
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}

.carousel-image {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: var(--primary-transparent);
}

.img-card {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.no-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle.big {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hover-content {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.carousel-image:hover .hover-content {
  opacity: 1;
}

.social-icons {
  display: flex;
  gap: 15px;
  font-size: 24px;
}

.connect-text {
  margin-top: 10px;
  color: white;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 2px;
}

.badge-container {
  position: absolute;
  top: 10px;
  left: 10px;
}

.badge {
  color: #fff;
  font-size: 12px;
  padding: 5px 10px;
  border-radius: var(--radius);
}

.image-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary-dark);
  z-index: 5;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
